// Unreal-style pin-capacity policy for interactive edge connects (ENG-877).
//
// When the user draws a new wire, some existing wires must be displaced —
// exactly as Unreal Blueprint does it:
//
//   - DATA input pins hold ONE wire: connecting a new source replaces
//     whatever fed that input.
//   - EXEC output pins hold ONE wire: dragging a new exec wire out of a node
//     re-routes its flow (two outgoing exec wires would double-fire the
//     chain in EventRuntime, which walks every matching edge).
//   - EXEC input pins accept MANY wires (several chains may converge on one
//     node), and DATA output pins fan out freely.
//
// Exec pins are identified by the repo-wide handle convention: every exec
// handle id starts with "exec" (execIn / execOut / execTrue / execFalse —
// see src/components/nodes/*). An edge is an exec edge iff it terminates at
// an exec input.
//
// Pure function so the policy is unit-testable: returns the edge list with
// the displaced wires removed; the caller then addEdge()s the new one.

export function isExecHandle(handleId) {
  return typeof handleId === 'string' && handleId.startsWith('exec')
}

export function dropDisplacedEdges(edges, params) {
  if (!Array.isArray(edges)) return []
  if (!params) return edges
  if (isExecHandle(params.targetHandle)) {
    // Exec wire: the SOURCE exec output is single-capacity.
    return edges.filter(e =>
      !(e.source === params.source && e.sourceHandle === params.sourceHandle)
    )
  }
  // Data wire: the TARGET input is single-capacity.
  return edges.filter(e =>
    !(e.target === params.target && e.targetHandle === params.targetHandle)
  )
}
